<template>
    <div class="footer">
        <div class="footer-box">
            <div class="logo-box">
                <img src="../assets/logo-1.png" class="logo-1">
                <div class="text">
                    由深諳國際市場環境的資深團隊為國內品牌企業提供海外社交媒體平台的運營管理服務，以國際化視野開拓全球市場，建立並提升本土品牌進入國際市場的全球影響力。
                </div>
            </div>
            <div class="menu-box">
                <p @click="selectMenu(1)">> 首頁</p>
                <p @click="selectMenu(2)">> 核心業務</p>
                <p @click="selectMenu(3)">> 關於我們</p>
                <p @click="selectMenu(4)">> 加入團隊</p>
                <p @click="selectMenu(5)">> 聯繫我們</p>
            </div>
            <div class="connect">
                <p>電話：00852-39622878</p>
                <p>郵箱：Leslie@fleuswordco-limited.com</p>
                <p>地址：UNIT 08, 15/F WITTY COMMERCIAL BUILDING 1A-1L TUNG CHOI STREET, KOWLOON HONG KONG</p>
            </div>
        </div>
        <!-- <div class="copyright">
            © WAVETECMOBI LIMITED
        </div> -->
    </div>
</template>
<script>
export default {
    name: "Menu",
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            index: 0
        };
    },
    methods: {
        selectMenu(value) {
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "business" }); break;
                case 3: this.$router.push({ path: "us" }); break;
                case 4: this.$router.push({ path: "offers" }); break;
                case 5: this.$router.push({ path: "aboutUs" }); break;
                // case 5: this.$router.push({ path: "cooperate" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
            // 跳转页面后，滚动到页面顶部
            window.scrollTo(0, 0);
        }
    }
}
</script>
<style lang="less" scoped>
.footer {
    .footer-box {
        height: 240px;
        background: #404040;
        padding: 120px 360px 106px 360px;
        display: flex;
        justify-content: space-between;

        .logo-box {
            width: 302px;
            font-size: 20px;
            font-weight: 400;
            color: #999999;

            .logo-1 {
                width: 242px;
                height: 40px;
            }

            .text {
                margin-top: 35px;
            }
        }

        .menu-box {
            font-size: 18px;
            font-weight: 500;
            color: #FFFFFF;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            height: 300px;

            p {
                cursor: pointer;
            }
        }

        .connect {
            font-size: 18px;
            font-weight: 500;
            color: #FFFFFF;
            width: 400px;
            height: 200px;
            display: flex;
            flex-direction: column;
            // align-items: center;
            justify-content: space-between;
        }

        .customer {
            width: 120px;
            font-size: 18px;
            font-weight: 500;
            color: #FFFFFF;
        }
    }

    .copyright {
        height: 64px;
        background: #2D2D2D;
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 64px;
        text-align: center;
    }
}
</style>